// /*** To get Cutomer Id / Shop Domain / Session Id For Wishlist***/
// const shopDomain = window.Shopify.shop;

// /*** Add Product In Wishlist Start ***/
// function addRemoveProductToWishlist(productId,productType) {  
//   var customerEmail = jQuery("#customer_email").val(); 
//   if(customerEmail == ''){
//     $(".quantum-lbw-wishlist-login-modal").addClass('show');
//     return false;
//   }
  
//   var postData = {
//     "customerEmail" : customerEmail,
//     "productId" : productId,
//     "shopUrl" : shopDomain
//   };

//   wishlistAjaxDataCalls(postData,productId,productType);
// }
// /*** Add Product In Wishlist End ***/

// /*** Add & Remove Product From Wishlist Start ***/
// function wishlistAjaxDataCalls(postData,productId,productType){
//   var wishlistApiUrl = "https://wishlist.gropulse.com/quantum_lbw_login_based_wishlist_data";
   
//   jQuery.ajax({
//     url: wishlistApiUrl,
//     type: 'post',
//     async: 'false',
//     data: postData,
//     success: function(response){
//       var wishlistProductArray = response.updatedLoginBasedWishlist;
//       var wishlistProductCount = wishlistProductArray.length;

//       $(".tps_wishlist_count").html(wishlistProductCount);
//         console.log(productId);
//       if($.inArray(productId, wishlistProductArray)!=(-1)){   
//         if(productType === 'product'){
//           $(".tps-product-wishlist-"+productId+" path").attr("d", "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z");
//           $(".tps-product-remove-from-wishlist").addClass("show");
//           setTimeout(function() { $(".tps-product-remove-from-wishlist").removeClass('show'); }, 2000);
//         }else{
//           jQuery(".tps-wishlist-text").html(translations.titleRemoveFromWishlist);
//           jQuery(".tps-add-diamond-to-wishlist-"+productId+" .tps-wishlist-icon").removeClass('tps-wishlist-heart-icon').addClass('tps-wishlist-heart-fill-icon');
//           jQuery(".tps-product-remove-from-wishlist").addClass('show');
//           setTimeout(function() { $(".tps-product-remove-from-wishlist").removeClass('show'); }, 2000);
//         }
//       }else{
//         // console.log("remove from wishlist"); 
//         if(productType === 'product'){
//           $(".tps-product-wishlist-"+productId+" path").attr("d", "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.920 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z");
//           $(".tps-product-added-to-wishlist").addClass("show");
//           setTimeout(function() { $(".tps-product-added-to-wishlist").removeClass('show'); }, 2000);
//         }else{
//           jQuery(".tps-wishlist-text").html(translations.titleAddToWishlist);
//           // jQuery(".tps-wishlist-icon").removeClass('tps-wishlist-heart-fill-icon').addClass('tps-wishlist-heart-icon');
//           jQuery(".tps-add-diamond-to-wishlist-"+productId+" .tps-wishlist-icon").removeClass('tps-wishlist-heart-fill-icon').addClass('tps-wishlist-heart-icon');
//           jQuery(".tps-product-added-to-wishlist").addClass('show');
//           setTimeout(function() { $(".tps-product-added-to-wishlist").removeClass('show'); }, 2000);
//         }
//       }     
//     }
//   });
// }
// /*** Add & Remove Product From Wishlist End ***/

// /*** Get Wishlist Product Count Start ***/
// function getWishlistProducts() {
//     var customerEmail = jQuery("#customer_email").val(); 
//     var wishlistApiUrl = "https://wishlist.gropulse.com/quantum_lbw_login_based_wishlist_data?shop_url="+shopDomain+"&customer_email="+customerEmail;

//     if(customerEmail != ''){              
//         jQuery.ajax({
//           url: wishlistApiUrl,
//           type: 'get',
//           async: 'false',
//           success: function(response){
           
//             var wishlistProductArray = response.wishlistItems;
//             var wishlistProductCount = wishlistProductArray.length; 

//             $(".tps_wishlist_count").html(wishlistProductCount);
//             $("#wishlist_products").val(wishlistProductArray);
//             // return wishlistProductArray;
               
//             getAllDiamondProducts();   
//           }
//         });
//     }    
// }
// /*** Get Wishlist Product Count End ***/

// function getAllDiamondProducts() {
//   var xhr = '';
//   // var wishlistProducts = $("#wishlist_products").val();
//   // wishlistProducts = wishlistProducts.split(',');

//   var wishlistProducts = jQuery("#wishlist_products").val()?.split(",") || [];
  
//   console.log(wishlistProducts);
//   //var diamondCollectionUrl = shopUrl+'/collections/'+diamondCollectionHandel+'/products.json?limit=500'; //get diamond products using shopify api
//   var diamondCollectionUrl = shopUrl+'/collections/diamonds/products.json?limit=500'; //get diamond products using shopify api

//   abortAjax(xhr);

//   xhr = $.ajax({
//      type: 'GET',
//      url: diamondCollectionUrl,
//      dataType: 'json',
//      success: function (data){      
       
//        var responseDiamondProducts = data.products;
//        //console.log('responseDiamondProducts',responseDiamondProducts);
//        var diamondProducts = [];
       
//       // console.log(responseDiamondProducts.length);
//        $.each(responseDiamondProducts, function(key,product){ 
//          // console.log(product);
//          var productId = product.id;  
//          var diamondId = product.options[0].values;
                  
//          var productOptions = product.options;    
//          $(productOptions).each(function(index, option){           
//            // if($.inArray(diamondId.toString(), wishlistProducts)!=(-1)){ 
//            if($.inArray(productId.toString(), wishlistProducts)!=(-1)){ 
//              if(option.name == 'Diamond Id'){                
//                 var diamond_id = option.values[0];              
//                 diamondProducts.push(diamond_id);                
//              }
//            }
//          });       
//        });
       
//        //return diamondProducts;     
      
//        jQuery('#diamond_products').val(diamondProducts);
//        // console.log('diamondProducts',diamondProducts);
//        graphqlDataCall();
//      }
//   });
// }

// /*** Abort XHR Start ***/
// function abortAjax(xhr) {
//   if(xhr && xhr.readystate != 4){
//     xhr.abort();
//   }
// }
// /*** End ***/ 

/*** To get Customer Id / Shop Domain / Session Id For Wishlist ***/
// Safe way to get shop domain
const shopDomain = window.Shopify && window.Shopify.shop 
  ? window.Shopify.shop 
  : document.querySelector('meta[name="shop-domain"]')?.content || '';

// OPTIONAL: In your theme.liquid layout, add this line inside <head> for the fallback to work
// <meta name="shop-domain" content="{{ shop.domain }}">

/*** Add Product In Wishlist Start ***/
function addRemoveProductToWishlist(productId, productType) {
  var customerEmail = jQuery("#customer_email").val();
  if (customerEmail == '') {
    $(".quantum-lbw-wishlist-login-modal").addClass('show');
    return false;
  }

  var postData = {
    "customerEmail": customerEmail,
    "productId": productId,
    "shopUrl": shopDomain
  };

  wishlistAjaxDataCalls(postData, productId, productType);
}
/*** Add Product In Wishlist End ***/

/*** Add & Remove Product From Wishlist Start ***/
function wishlistAjaxDataCalls(postData, productId, productType) {
  var wishlistApiUrl = "https://wishlist.gropulse.com/quantum_lbw_login_based_wishlist_data";

  jQuery.ajax({
    url: wishlistApiUrl,
    type: 'post',
    async: 'false',
    data: postData,
    success: function (response) {
      var wishlistProductArray = response.updatedLoginBasedWishlist;
      var wishlistProductCount = wishlistProductArray.length;

      $(".tps_wishlist_count").html(wishlistProductCount);
      console.log(productId);
      if ($.inArray(productId, wishlistProductArray) != -1) {
        if (productType === 'product') {
          $(".tps-product-wishlist-" + productId + " path").attr("d", "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z");
          $(".tps-product-remove-from-wishlist").addClass("show");
          setTimeout(function () { $(".tps-product-remove-from-wishlist").removeClass('show'); }, 2000);
        } else {
          jQuery(".tps-wishlist-text").html(translations.titleRemoveFromWishlist);
          jQuery(".tps-add-diamond-to-wishlist-" + productId + " .tps-wishlist-icon").removeClass('tps-wishlist-heart-icon').addClass('tps-wishlist-heart-fill-icon');
          jQuery(".tps-product-remove-from-wishlist").addClass('show');
          setTimeout(function () { $(".tps-product-remove-from-wishlist").removeClass('show'); }, 2000);
        }
      } else {
        if (productType === 'product') {
          $(".tps-product-wishlist-" + productId + " path").attr("d", "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.920 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z");
          $(".tps-product-added-to-wishlist").addClass("show");
          setTimeout(function () { $(".tps-product-added-to-wishlist").removeClass('show'); }, 2000);
        } else {
          jQuery(".tps-wishlist-text").html(translations.titleAddToWishlist);
          jQuery(".tps-add-diamond-to-wishlist-" + productId + " .tps-wishlist-icon").removeClass('tps-wishlist-heart-fill-icon').addClass('tps-wishlist-heart-icon');
          jQuery(".tps-product-added-to-wishlist").addClass('show');
          setTimeout(function () { $(".tps-product-added-to-wishlist").removeClass('show'); }, 2000);
        }
      }
    }
  });
}
/*** Add & Remove Product From Wishlist End ***/

/*** Get Wishlist Product Count Start ***/
function getWishlistProducts() {
  var customerEmail = jQuery("#customer_email").val();
  var wishlistApiUrl = "https://wishlist.gropulse.com/quantum_lbw_login_based_wishlist_data?shop_url=" + shopDomain + "&customer_email=" + customerEmail;

  if (customerEmail != '') {
    jQuery.ajax({
      url: wishlistApiUrl,
      type: 'get',
      async: 'false',
      success: function (response) {

        var wishlistProductArray = response.wishlistItems;
        var wishlistProductCount = wishlistProductArray.length;

        $(".tps_wishlist_count").html(wishlistProductCount);
        $("#wishlist_products").val(wishlistProductArray);

        getAllDiamondProducts();
      }
    });
  }
}
/*** Get Wishlist Product Count End ***/

function getAllDiamondProducts() {
  var xhr = '';

  var wishlistProducts = jQuery("#wishlist_products").val()?.split(",") || [];

  console.log(wishlistProducts);
  var diamondCollectionUrl = shopDomain + '/collections/diamonds/products.json?limit=500';

  abortAjax(xhr);

  xhr = $.ajax({
    type: 'GET',
    url: diamondCollectionUrl,
    dataType: 'json',
    success: function (data) {

      var responseDiamondProducts = data.products;
      var diamondProducts = [];

      $.each(responseDiamondProducts, function (key, product) {
        var productId = product.id;
        var diamondId = product.options[0].values;

        var productOptions = product.options;
        $(productOptions).each(function (index, option) {
          if ($.inArray(productId.toString(), wishlistProducts) != -1) {
            if (option.name == 'Diamond Id') {
              var diamond_id = option.values[0];
              diamondProducts.push(diamond_id);
            }
          }
        });
      });

      jQuery('#diamond_products').val(diamondProducts);
      graphqlDataCall();
    }
  });
}

/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if (xhr && xhr.readystate != 4) {
    xhr.abort();
  }
}
/*** End ***/ 


